import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.scss';
import Konferenz from './Konferenz';
import Logger from './lib/Logger';
import UrlParse from 'url-parse';
import domready from 'domready'
import randomString from 'random-string';
import { Provider as ReduxProvider } from 'react-redux';
import { createStore } from './redux/store';
import debug from 'debug';
import i18nextInit from './i18n';
import RoomClient, {VIDEO_CONSTRAINTS, VIDEO_CODECS, DEFAULT_CODEC} from './lib/RoomClient';
import RoomContext from './lib/RoomContext';
import { setMe, setRoomUrl } from './redux/actions';

i18nextInit();

debug.enable('Konferenz:*');
// debug.enable('*');
const log = new Logger();

const reduxStore = createStore();

domready(async () => {
  log.debug('DOM ready.');

  const urlParser = new UrlParse(window.location.href, true);
  let roomId = urlParser.pathname.substr(1);
  const peerId = randomString({ length: 16 }).toLowerCase();
  const displayName = localStorage.getItem('displayName');

  let codec = DEFAULT_CODEC;
  if (urlParser.query['codec'] && VIDEO_CODECS.has(urlParser.query['codec'])) {
    codec = urlParser.query['codec'];
  }
  let resolution = 'fhd';
  if (urlParser.query['resolution'] && VIDEO_CONSTRAINTS.has(urlParser.query['resolution'])) {
    resolution = urlParser.query['resolution'];
  }

  let produce = true;
  if (urlParser.query['consumeOnly']) {
    produce = false;
  }

  if (!roomId) {
    roomId = randomString({ length: 8 });
    urlParser.set('pathname', `/${roomId}`);
    window.history.pushState(null, '', urlParser.toString());
  }

  const roomUrl = urlParser.toString();

  reduxStore.dispatch(setRoomUrl(roomUrl));
  reduxStore.dispatch(setMe({
    id: peerId,
    displayName: displayName
  }));

  if (produce) {
    try {
      navigator.mediaDevices.getUserMedia({
        audio: true
      })
      .then((stream) => {
        console.log('ok')
        stream.getTracks().forEach(track => track.stop());
      })
      .catch(e => console.log(e));

    } catch (e) {
      console.log(e);
    }
  }

  const roomClient = new RoomClient({
    reduxStore,
    roomId,
    peerId,
    produce,
    consume: true,
    preferredCodec: codec,
    preferredResolution: resolution
  });

  (window as any).CLIENT = roomClient;

  ReactDOM.render(
    <React.StrictMode>
      <ReduxProvider store={reduxStore}>
        <RoomContext.Provider value={roomClient}>
          <Konferenz />
        </RoomContext.Provider>
      </ReduxProvider>
    </React.StrictMode>,
    document.getElementById('root')
  );
});
